<div class="welcome-container">
  <h2 class="welcome-title">{{ 'fee.welcome' | translate }}</h2>
  <p class="welcome-subtitle">{{ 'fee.select_user_card_and_setup' | translate }}</p>

  @if (isLoadingCards) {
    <div class="setup-card cards-loading-state">
      <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else if (userCards.length === 0) {
    <div class="setup-card no-cards-state">
      <p class="no-cards-message">{{ 'fee.all_cards_linked' | translate }}</p>
      <button class="filled-button short-button button-md no-cards-action-btn"
              type="button"
              (click)="goToIndividualCards()">
        {{ 'fee.go_to_individual_cards' | translate }}
      </button>
    </div>
  } @else {
    <div class="setup-card">
      <div class="card-select-wrap">
        <button class="card-usernames-field"
                type="button"
                (click)="toggleCardMenu($event)">
          <span class="field-label">{{ 'menu_management.card_username' | translate }}</span>
          <span class="field-value">{{ selectedCardLabel }}</span>
          <span class="field-chevron" [class.field-chevron--open]="isCardMenuOpen"></span>
        </button>

        @if (isCardMenuOpen) {
          <div class="card-options-menu">
            @for (card of userCards; track card.id) {
              <button class="card-option"
                      type="button"
                      [class.card-option--active]="selectedCard?.id === card.id"
                      (click)="selectCard(card, $event)">
                <span>{{ formatCardLabel(card) }}</span>
                @if (selectedCard?.id === card.id) {
                  <span class="card-option-check">✓</span>
                }
              </button>
            }
          </div>
        }
      </div>

      <button class="setup-btn" type="button"
              [disabled]="!selectedCard"
              (click)="onSetup()">
        {{ 'fee.setup' | translate }}
      </button>
    </div>
  }
</div>
